import { render } from "./AggregatedPageWrapper.vue?vue&type=template&id=5a151bf3&scoped=true&ts=true"
import script from "./AggregatedPageWrapper.vue?vue&type=script&lang=ts"
export * from "./AggregatedPageWrapper.vue?vue&type=script&lang=ts"

import "./AggregatedPageWrapper.vue?vue&type=style&index=0&id=5a151bf3&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a151bf3"]])

export default __exports__